<template>
  <el-dialog :title="dialogTitle" :visible.sync="open" :center="true" width="80%" @close="cancel" :close-on-click-modal="false">

    <div class="tipColumn">
      <template v-for="(item, index) in tipColumOptions">
        <span class="tipColumn1" :key="index">{{item.name}}: {{item.value}} </span>
      </template>
    </div>

    <div style="height:520px">

      <el-table :data="dataList" border height="500" :center="true" style="width: auto; margin: 0 10px" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template v-for="(item) in columOptions">
          <el-table-column v-if="item.type=='date'" show-overflow-tooltip :prop="item.key" :min-width="item.width || 120" :label="item.label" :key="item.label">
            <template slot-scope="scope">
              {{scope.row[item.key] ? parseTime(new Date(scope.row[item.key]), "{y}-{m}-{d}") : ''}}
            </template>
          </el-table-column>
          <el-table-column v-else-if="item.type=='datetime'" show-overflow-tooltip :prop="item.key" :min-width="item.width || 120" :label="item.label" :key="item.label">
            <template slot-scope="scope">
              {{scope.row[item.key] ? parseTime(new Date(scope.row[item.key])) : ''}}
            </template>
          </el-table-column>
          <el-table-column v-else show-overflow-tooltip :prop="item.key" :min-width="item.width || 120" :label="item.label" :key="item.label"></el-table-column>
        </template>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin";

export default {
  components: {},
  name: "selectDialog",
  mixins: [GetDataMixin],
  data () {
    return {
      open: false,
      tableData: [],
      // keyWord: '',
      defaultProps: {
        children: "children",
        label: "name",
      },
      query: {
        pageIndex: 1,
        pageSize: 20,
        type: this.moveLibrayType,
        id: this.id
      },
      list: [],
      total: 0,

      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      loading: false
    };
  },
  props: {
    show: {
      type: Boolean,
      default () {
        return false;
      },
    },
    dialogTitle: {
      type: String,
      default () {
        return '';
      },
    },
    dataList: {
      type: Array,
      default () {
        return []
      }
    },
    columOptions: {
      type: Array,
      default () {
        return []
      }
    },
    tipColumOptions: {
      type: Array,
      default () {
        return []
      }
    },
    getDataFunction: {
      type: Function,
      default () {
        return () => { }
      }
    },
    // moveLibrayType: {
    //   type: Number,
    //   default () {
    //     return 1
    //   }
    // },
    // id: {
    //   type: Number,
    //   default () {
    //     return 0
    //   }
    // },

  },
  created () {

  },
  methods () {

  },
  watch: {
    show (val, oldVal) {
      this.open = val;
      if (this.open) {
        this.childIds = []
        this.childMultipleSelection = []
        this.childMultiple = false

        if (this.$refs.childTable) {
          this.$refs.childTable.clearSelection()
        }
      }
    },
    // filterOptions: {
    //   handler (newVal, oldVal) {
    //     console.log(newVal, oldVal)
    //   },

    //   deep: true
    // }
  },
  methods: {
    cancel () {
      this.open = false;
      this.$emit("close");
    },
    submit () {
      this.open = false;
      this.$emit("returnData", this.childMultipleSelection);
    },
    getData () {
      // this.tableData = this.receiveTableData;
      // console.log(this.receiveTableData, "this.receiveTableData");
      this.loading = true
      this.getDataFunction(this.query)
        .then(res => {
          this.list = res.returnData.data
          if (!this.pageAuto) {
            this.total = this.list ? this.list.length : 0;
            this.tableData = this.getPaginationData(this.list, this.query.pageIndex, this.query.pageSize)
          } else {
            this.total = res.returnData.totalCount;
            this.tableData = this.list;
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    getPaginationData (list, pageIndex, pageSize) {
      return list.slice((pageIndex - 1) * pageSize, pageIndex * pageSize)
    },

    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      if (!this.pageAuto) {
        this.tableData = this.getPaginationData(this.list, this.query.pageIndex, this.query.pageSize)
      } else {
        this.getData();
      }
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 重置
    reset () {
      // this.query = {
      //   pageSize: 20,
      //   pageIndex: 1,
      // };
      this.resetQuery()
      this.$set(this.query, "pageIndex", 1);
      this.$set(this.query, "pageSize", 10);

    },



  },
};
</script>

<style lang="scss" scoped>
/deep/.el-table {
  overflow: visible !important;
}
.tipColumn {
  background-color: bisque;
  margin: 0px 10px 10px;
  height: 39px;
  line-height: 39px;
  font-size: 16px;
  border-bottom: 1px solid;
  border-top: 1px solid;
  // text-overflow: ellipsis;
}
.tipColumn1 {
  // margin: 0 0 0 12px;
  margin-left: 12px;
}
div /deep/.el-table__body-wrapper {
  max-height: 348px !important;
}
</style>
